module.exports = __webpack_public_path__ + "static/img/PIA-sponsor-logo.5121aaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/PIA-sponsor-logo.jpg
// module id = i39t
// module chunks = 0